import classes from "./CarouselItem.module.css";

const CarouselItem = ({ item }) => {
  return (
    <div className={classes.container}>
      <img className={classes.img} src={item.src} />
    </div>
  );
};

export default CarouselItem;
